import React from "react";

const PageHeading = (props) => {
    return (
        <div className="layout-breadcrumb-container flex flex-wrap justify-content-between align-items-center shadow-1 mb-0 sm:mb-2 pt-2 sm:pt-1 pb-1 sm:pb-0">
            <div className="m-2 ml-3 sm:m-3 sm:ml-5 flex flex-inline align-items-center">
                <span className="m-0 text-xl font-semibold sm:text-2xl">{props.pageTitle}</span>
            </div>
            <div className="mb-1 ml-3 sm:ml-5 mr-2 sm:mr-3 flex align-items-right">{props.children}</div>
        </div>
    );
};

export default PageHeading;
